<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd = true">新增</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="entrust_id">
                            <el-input v-model="formInline.entrust_id" placeholder="委托单位id"></el-input>
                        </el-form-item>
                        <el-form-item prop="serial">
                            <el-input v-model="formInline.serial" placeholder="委托编号"></el-input>
                        </el-form-item>
                        <el-form-item prop="date">
                            <el-date-picker v-model="formInline.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeDate">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="entrust_phone">
                            <el-input v-model="formInline.entrust_phone" placeholder="姓名"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 新增回款单 --> 
                <el-dialog custom-class="huikuanDialog" title="新增回款单" :visible.sync="handleAdd" width="500px" center @close="dialogClose">
                    <el-form :model="form" :rules="addrules" ref="form" label-width="120px">
                        <el-form-item label="委托单：" prop="construction_unit">
                            <el-select v-model="form.construction_unit" placeholder="请选择委托单" style="width: 290px;" @change="constructionUnitChange($event)" value-key="contract_id">
                                <el-option v-for="item in constructionUnitList" :key="item.contract_id" :value="item" :label="item.construction_unit">{{ item.construction_unit }}</el-option>
                            </el-select>
                            <el-input v-model="form.contract_id" type="hidden" style="display: none;"></el-input>
                        </el-form-item>
                        <el-form-item label="回款方：" prop="contract_name">
                            <el-select v-model="form.contract_name" placeholder="请选择回款方" style="width: 290px;" @change="contractNameChange($event)" value-key="id">
                                <el-option v-for="item in danweiList" :key="item.id" :value="item" :label="item.name">{{ item.name }}</el-option>
                            </el-select>
                            <el-input v-model="form.entrust_id" type="hidden" style="display: none;"></el-input>
                        </el-form-item>
                        <el-form-item label="账户名称：" prop="account_name">
                            <el-select v-model="form.account_name" placeholder="请选择账户名称" style="width: 290px;" @change="accountNameChange($event)" value-key="id">
                                <el-option v-for="item in accountNameList" :key="item.id" :value="item" :label="item.name">{{ item.name }}</el-option>
                            </el-select>
                            <el-input v-model="form.account_id" type="hidden" style="display: none;"></el-input>
                        </el-form-item>
                        <el-form-item label="账号/卡号：" prop="collect_card">
                            <el-input v-model="form.collect_card" autocomplete="off" readonly placeholder="" style="width: 290px;"></el-input>
                        </el-form-item>
                        <el-form-item label="收款金额：" prop="collect_money">
                            <el-col :span="7.5">
                                <el-form-item>
                                    <el-input v-model="form.collect_money" autocomplete="off" type="number" placeholder="0.00" class="numberInput" min="0" style="width: 100px;"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7.5">
                                <el-form-item label="操作人：" label-width="90px" prop="operator">
                                    <el-input v-model="form.operator" autocomplete="off" placeholder="" style="width: 100px;"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="收款时间：" prop="collecttime">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.collecttime" value-format="timestamp" style="width: 290px;"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="备注：" style="margin-bottom: 0;" prop="remarks">
                            <el-input type="textarea" placeholder="" v-model="form.remarks" style="width: 290px;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleAdd = false">取消</el-button>
                        <el-button type="primary" @click="submitFormAdd('form')">确认</el-button>
                    </div>
                </el-dialog>
                <div class="bot">
                    <el-table
                        class="huikuan"
                        ref="singleTable"
                        v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="95%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="collect_money"
                        label="收款金额（￥）"
                        width="155">
                            <template slot-scope="scope">
                                ￥{{ scope.row.collect_money }}    
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="ymoney"
                        label="应收款（￥）"
                        width="155">
                            <!-- <template slot-scope="scope">
                                ￥{{ scope.row.ymoney }}    
                            </template> -->
                        </el-table-column>
                        <el-table-column
                        prop="contract_name"
                        label="付款方"
                        width="220">
                        </el-table-column>
                        <el-table-column
                        prop="operator"
                        label="操作人"
                        width="155">
                        </el-table-column>
                        <el-table-column
                        prop="serial"
                        label="委托编号"
                        width="155">
                        </el-table-column>
                        <el-table-column
                        prop="collecttime"
                        :formatter="dateFormat"
                        label="应收款时间"
                        width="155">
                        </el-table-column>
                        <el-table-column
                        prop="remarks"
                        fixed="right"
                        label="备注"
                        width="300">
                        </el-table-column>
                    </el-table>
                    <div class="page flex">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                        <div class="sk flex">
                            <div class="li">总计应收：<em>￥{{ yingTotal }}元</em></div>
                            <div class="li">总计已收：<em>￥{{ yiTotal }}元</em></div>
                            <div class="li">总计未收：<em>￥{{ weiTotal }}元</em></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import { finance_returned_index, finance_returned_add, finance_returned_del, basis_entrust_index, detection_task_index, basis_account_index } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 委托单id
                constructionUnitList: [],
                // 委托单位列表
                danweiList: [],
                // 账户列表
                accountNameList: [],
                // 新增回款单弹窗默认隐藏
                handleAdd: false,
                form: {
                    contract_id: '',
                    construction_unit: '', // 施工单位
                    entrust_id: '',
                    contract_name: '',
                    account_name: '',
                    account_id: '',
                    collect_card: '',
                    collect_money: '',
                    operator: '',
                    collecttime: '',
                    remarks: ''
                },
                  addrules: {
                    construction_unit: [
                        { required: true, message: '请选择委托单id', trigger: 'blur' }
                    ],
                    contract_name: [
                        { required: true, message: '请选择回款方', trigger: 'blur' }
                    ],
                    account_name: [
                        { required: true, message: '请选择账户', trigger: 'blur' }
                    ],
                    collect_money: [
                        { required: true, message: '请输入收款金额', trigger: 'blur' }
                    ],
                    operator: [
                        { required: true, message: '请输入操作人', trigger: 'blur' }
                    ],
                    collecttime: [
                        { required: true, message: '请选择收款时间', trigger: 'blur' }
                    ]
                },
                yingTotal: '0.00',
                yiTotal: '0.00',
                weiTotal: '0.00',
                // 筛选
                start_time: '', // 开始日期
                end_time: '', // 结束日期
                formInline: {
                    entrust_id: '',
                    serial: '',
                    date: '',
                    entrust_phone: ''
                },
                rules: {
                    entrust_id: [
                        { required: false, message: '请输入委托单位id', trigger: 'blur' }
                    ],
                    serial: [
                        { required: false, message: '请输入委托编号', trigger: 'blur' }
                    ],
                    date: [
                        { required: false, message: '请选择委托日期', trigger: 'change' }
                    ],
                    entrust_phone: [
                        { required: false, message: '请输入姓名', trigger: 'blur' }
                    ]
                },
                // 数据列表
                loading: false,
                tableData: [],
                total: 0,
                per_page: 10, //每页多少数据
                page: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 日期范围回显
                changeDate(e) {
                    // console.log(e[0], e[1]);
                    this.start_time = e[0]; // 开始日期
                    this.end_time = e[1]; // 结束日期
                },
                // 列表
                financeReturnedIndex() {
                    this.loading = true;
                    finance_returned_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 付款方 委托单位列表
                basisEntrustIndex() {
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.danweiList = res.data.data.data
                        }
                    });
                },
                // 委托单id
                detectionTaskIndex() {
                    detection_task_index().then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.constructionUnitList = res.data.data.data;
                        }
                    });
                },
                // 账户列表
                basisAccountIndex() {
                    basis_account_index().then((res) => {
                        // console.log(res.data.data);
                        if (res.data.code == 1) {
                            this.accountNameList = res.data.data.data;
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                            
                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        finance_returned_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.financeReturnedIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            finance_returned_index({
                                params: {
                                    entrust_id: this.formInline.entrust_id,
                                    serial: this.formInline.serial,
                                    entrust_phone: this.formInline.entrust_phone,
                                    start_time: this.start_time,
                                    end_time: this.end_time,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 委托单id
                constructionUnitChange(event) {
                    // console.log(event.construction_unit,event.contract_id);
                    this.form.construction_unit = event.construction_unit;
                    this.form.contract_id = event.contract_id
                },
                // 回款方
                contractNameChange(event) {
                    // console.log(event.name,event.id);
                    this.form.contract_name = event.name;
                    this.form.entrust_id = event.id
                },
                // 账户名称
                accountNameChange(event) {
                    // console.log(event.name,event.id,event.card);
                    this.form.account_name = event.name;
                    this.form.account_id = event.id;
                    this.form.collect_card = event.card
                },  
                // 新增回款单
                submitFormAdd(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(new Date(this.form.collecttime) / 1000);
                            finance_returned_add({
                                contract_id: this.form.contract_id,
                                construction_unit: this.form.construction_unit,
                                entrust_id: this.form.entrust_id,
                                contract_name: this.form.contract_name,
                                account_name: this.form.account_name,
                                account_id: this.form.account_id,
                                collect_card: this.form.collect_card,
                                collect_money: this.form.collect_money,
                                operator: this.form.operator,
                                collecttime: new Date(this.form.collecttime) / 1000,
                                remarks: this.form.remarks
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.code == 1) {
                                    // this.page = 1;
                                    this.handleAdd = false;
                                    this.financeReturnedIndex(); // 调用数据列表函数
                                }
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                });
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // dislog弹窗关闭清除数据以及验证
                dialogClose() {
                    this.$refs['form'].resetFields(); // 清除验证提示文字
                    // this.form.name = '';
                    // this.form.price = '';
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    detection_task_index({
                        params: { page }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                        }
                    });
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.collecttime*1000)
                    let data = row.collecttime * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                },
            },
            created() {
                this.financeReturnedIndex(); // 列表
                this.basisEntrustIndex(); // 付款方 委托单位列表
                this.detectionTaskIndex(); // 委托单id列表
                this.basisAccountIndex()  // 账户列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
        .huikuan .el-table__row td:nth-child(3) .cell{
            color: #409EFF;
        }
        .huikuan .el-table__row td:last-child .cell{
            line-height: 32px;
            /* overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis; */
        }
        /* 去除input类型number右侧箭头图标 */
        .numberInput::-webkit-outer-spin-button,
        .numberInput::-webkit-inner-spin-button{
            -webkit-appearance: none;
        }
        input[type="number"]{
            -moz-appearance: textfield;
        }
  </style>
  


// WEBPACK FOOTER //
// src/components/huikuan.vue